import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { environment } from '../../../environments/environment';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';


declare var $:any;
declare var iziToast:any;


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  displayedProducts = []
  loading = true
  modelName = "Product";
  products: any;
  ready = false;

  categories = []

  constructor(
    private router: Router,
    private _data: CommonDataService,
    private _ecom: CommerceDataService
  ) { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
    $('#owl-initialise').trigger('click');

    this.getCategories()
    

    let queryData = new FormData();
    queryData.append('modelName', this.modelName);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelDataShopModels(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.products = data['covers'];
          this.displayedProducts = this.getValidProducts()
          this.loading = false
          this.ready = true
          $('#owl-initialise').trigger('click');

        },
        error => {

          console.log(error);
          iziToast.success({
            title: 'Error!',
            position: 'topRight',
            icon: 'icon-circle-check',
            message: 'Failed to get products.'
        });

        $('#loader').hide();

        },

        () => {
            $('#loader').hide();
        }
      );
  }

  getValidProducts() {
    // this.products.sort((a,b)=>a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name'].localeCompare(b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name']))

    return this.products.filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['ProductFlags']['published'] === false);
  }

  getProductImageSrc(modelData){

    if( modelData['files'] && modelData['files']['uploads'] && Array.isArray(modelData['files']['uploads']) && modelData['files']['uploads'].length > 0) {
      let productImages = modelData['files']['uploads']

      for (let index = 0; index < productImages.length; index++) {
        let element = productImages[index];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          return src
        }
        
      }

    }

      return ''
  }

  getCategoryImageSrc(modelData, imageIndex){

    if( modelData['files'] && modelData['files']['images'] && Array.isArray(modelData['files']['images']) && modelData['files']['images'].length > 0  ) {
      let productImages = modelData['files']['images']

      if(productImages[imageIndex] != undefined) {
        let element = productImages[imageIndex];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          
          return src
        }
      }



    }

      return ''
  }

  addToCart(product) {


    if(this._ecom.checkInstantAddToCart(product)) {
      product['variationId'] = 0
      this._ecom.addToShoppingCart(product, 1)

      iziToast.success({
          title: 'Success',
          position: 'topRight',
          icon: 'icon-circle-check',
          message: 'Product added to shopping cart.'
      });
    }

    else {
      this.router.navigate(['/shop/products/{{product["id"]']);
    }
  }

  getCategories() {

    let queryData = new FormData();
    queryData.append('modelName', "ShopCategory");

    this._data.getModelDataShopModels(queryData) 
    .pipe(first())
    .subscribe(
      data => {
        
        if(data['covers'].length > 0) {
          this.categories = data['covers'].filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['category_status'] == "active");
        }

        this.loading = false

      },
      error => {
      },

      () => {
      }
    );

  }

}
